// Spec 083 — a query string das rotas de navegação do assistente.
//
// Mora fora do `NAV_REGISTRY` porque o registry é DADO: 27 entradas declarativas, uma por tela.
// Uma função ali dentro empurra o arquivo contra o teto de 200 linhas a cada navegação nova, e o
// teto existe justamente para o registry não virar módulo de lógica.

/**
 * Monta a query string com as chaves PEDIDAS que estiverem presentes.
 *
 * Duas regras, e cada uma fecha um buraco:
 *  - o ausente é PULADO. Um `undefined` interpolado viraria a string "undefined" no endereço, e a
 *    tela leria um período que ninguém pediu — os opcionais existem para ela cair no padrão dela.
 *  - só as chaves NOMEADAS entram. `build` recebe o objeto de args inteiro, então copiar tudo que
 *    chega faz argumento alheio vazar para a URL: um `machineId` perdido no endereço do relatório
 *    não significa nada para a tela e confunde quem lê o link.
 */
export function navQueryString(args: Record<string, string>, keys: readonly string[]): string {
  const out = new URLSearchParams();
  for (const k of keys) {
    const v = args[k];
    if (v !== undefined && v !== null && v !== "") out.set(k, v);
  }
  return out.toString();
}

/**
 * Spec 084 — a query do CONTROLE DE PRODUÇÃO, com o recorte por característica e o quadro.
 *
 * Mora aqui pelo mesmo motivo do helper acima: o `NAV_REGISTRY` é dado, e um `build` com renomeação
 * de chave é lógica. E a renomeação existe porque a TELA lê nomes curtos (`char`, `compare`) — um
 * `characteristicId=` no endereço seria ignorado em silêncio, e o gestor veria o relatório inteiro
 * acreditando estar olhando o recorte.
 */
export function productionReportQuery(args: Record<string, string>): string {
  return navQueryString(
    {
      ...args,
      ...(args.characteristicId ? { char: args.characteristicId } : {}),
      ...(args.compareBy ? { compare: args.compareBy } : {}),
    },
    ["lineId", "scope", "from", "to", "groupBy", "char", "value", "compare"]
  );
}
